import React, { useState } from "react";
import { resetPassword } from "aws-amplify/auth";
import { useNavigate } from "react-router-dom";



export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const [userExists, setUserExists] = useState(true);


    const handleSubmit = async (e) => {
        e.preventDefault();
        setErr("");
        setLoading(true);

        const lowerEmail = email.toLowerCase();

        try {
            await resetPassword({ username: lowerEmail });

            // To handle that, we’ll simulate the missing-user case in catch below.
            navigate(`/reset-password?email=${encodeURIComponent(lowerEmail)}`);
        } catch (error) {
            console.error("Reset password error:", error);

            if (error.name === "UserNotFoundException") {
            // Actual Cognito error
            setErr("Looks like you don’t have an account. Please request an account.");
            setUserExists(false);
            } else if (error.message?.includes("username")) {

            setErr("Looks like you don’t have an account. Please request an account.");
            setUserExists(false);
            } else if (error.name === "LimitExceededException") {
            setErr("Too many attempts. Please try again later.");
            } else if (error.name === "InvalidParameterException") {
            setErr("Cannot reset password for this account. Please contact support.");
            } else {
            setErr(error.message || "Failed to send reset code. Please try again.");
            }
        } finally {
            setLoading(false);
        }
    };



  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-lg p-8">
        <div className="text-center mb-6">
          <img
            src="infauxtech_logo_rectangle.png"
            alt="Media Forensics Hub"
            className="w-32 mx-auto mb-4"
          />
          <h2 className="text-2xl font-bold text-purple-800">
            Forgot your password?
          </h2>
          <p className="text-gray-600 mt-2 text-sm">
            Enter your email address. We will send a message with a code to reset your password.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-left text-gray-700 font-medium mb-1">
              Email address
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-purple-500 focus:outline-none"
              placeholder="Enter your email"
              required
              autoComplete="email"
            />
          </div>
            <button
            type="submit"
            disabled={loading || !email || !userExists}
            className="w-full bg-purple-700 text-white font-semibold py-2 rounded-lg hover:bg-purple-800 transition disabled:opacity-50 disabled:cursor-not-allowed"
            >
            {loading ? "Sending code..." : "Reset my password"}
            </button>

            {!userExists && (
            <p className="mt-2 text-center text-sm text-purple-700">
                <a href="/request-account" className="font-semibold hover:underline">
                Request an account
                </a>
            </p>
            )}


        </form>

        {err && (
          <p className="mt-4 text-red-600 text-center font-medium text-sm">
            {err}
          </p>
        )}

        <div className="mt-6 text-center">
          <button
            onClick={() => navigate("/login")}
            className="text-purple-700 font-semibold hover:underline text-sm"
          >
            ← Back to sign in
          </button>
        </div>
      </div>
    </div>
  );
}
